import {
  buildResidentSmetaFloorOptionsFromRaw,
  formatResidentSmetaBlockEntranceLabel,
} from "@/_helpers/residentSmetaTree.js";
import { buildSmetaNewTableRows } from "@/_helpers/smetaNewTableRows";
import { getResidentialEntrances } from "@/views/ResidentialSettings/services/index.js";
import { projectsEntryAPI } from "@/views/ProjectsEntry/services/api";

export const getAllProjects = async (params) => {
  try {
    const res = await projectsEntryAPI.getList(params);
    return res?.data;
  } catch (e) { }
};
export const updProject = async (body, params) => {
  try {
    const res = await projectsEntryAPI.updProject(body, params);
    return res?.data;
  } catch (e) { }
};
export const updProjectLimit = async (body, params) => {
  try {
    const res = await projectsEntryAPI.updProjectLimit(body, params);
    return res?.data;
  } catch (e) { }
};
export const updWriteoffInfo = async (body) => {
  try {
    await projectsEntryAPI.updWriteoffInfo(body);
    return true;
  } catch (e) { }
};
export const getProjectInfo = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getProjectInfo(project_id);
    return res;
  } catch (e) { }
};
export const updProjectInfo = async (body) => {
  try {
    const res = await projectsEntryAPI.updProjectInfo(body);
    return res;
  } catch (e) { }
};
export const getEmployeeList = async () => {
  try {
    const res = await projectsEntryAPI.getEmployeeList();
    return res?.data;
  } catch (e) { }
};
export const getEntrancesBlockInfo = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getEntrancesBlockInfo(project_id);
    return res?.data;
  } catch (e) { }
};
export const updEntrancesBlockInfo = async (body) => {
  try {
    const res = await projectsEntryAPI.updEntrancesBlockInfo(body);
    return res?.data;
  } catch (e) { }
};
export const getContractorsList = async () => {
  try {
    const res = await projectsEntryAPI.getContractors();
    return res?.contractors;
  } catch (e) { }
};
export const getEmployeesListByContractorId = async (contractor_id) => {
  try {
    const res = await projectsEntryAPI.getEmployeesListByContractorId(
      contractor_id
    );
    return res?.data;
  } catch (e) { }
};
export const updateShellProjectPerfomancer = async (body) => {
  try {
    const res = await projectsEntryAPI.updateShellProjectPerfomancer(body);
    return res?.data;
  } catch (e) { }
};
export const getPerformersByProjectId = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getPerformersByProjectId(project_id);
    return res?.data;
  } catch (e) { }
};
export const getAssignTypes = async () => {
  try {
    const res = await projectsEntryAPI.getAssignTypes();
    return res?.data;
  } catch (e) { }
};
export const changeProjectStatus = async (project_id, params) => {
  try {
    const res = await projectsEntryAPI.changeProjectStatus(project_id, params);
    return res?.data;
  } catch (e) { }
};
export const getProjectStatusForChange = async () => {
  try {
    const res = await projectsEntryAPI.getProjectStatusForChange();
    return res?.data ?? res;
  } catch (e) {
    return [];
  }
};
export const changeProjectStatusById = async (body, params) => {
  try {
    const res = await projectsEntryAPI.changeProjectStatusById(body, params);
    return res?.data;
  } catch (e) { }
};
export const fillEntranceFlats = async (project_id, params) => {
  try {
    const res = await projectsEntryAPI.fillEntranceFlats(project_id, params);
    return res;
  } catch (e) { }
};
export const deleteShellProjectPerfomancer = async (body) => {
  try {
    const res = await projectsEntryAPI.deleteShellProjectPerfomancer(body);
    return res?.data;
  } catch (e) { }
};
export const copyPasteEntranceProperties = async (body, params) => {
  try {
    const res = await projectsEntryAPI.copyPasteEntranceProperties(
      body,
      params
    );
    return res?.data;
  } catch (e) { }
};
export const getHasGrant = async (grant_code) => {
  try {
    const res = await projectsEntryAPI.hasGrant(grant_code);
    return res?.has_access === true;
  } catch (e) {
    return false;
  }
};
export const transferEntranceProject = async (body, params) => {
  const res = await projectsEntryAPI.transferProject(body, params);
  if (res && res.status === false && res.error) {
    const err = new Error(res.error);
    err.response = { data: { error: res.error } };
    throw err;
  }
  return res?.data;
};
export const getProjectsById = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getProjectsById(project_id);
    return res?.data;
  } catch (e) { }
};
export const getWarranty = async (body) => {
  try {
    const res = await projectsEntryAPI.getWarranty(body);
    return res?.data ?? res;
  } catch (e) { }
};
export const generateDoc = async (body) => {
  try {
    const res = await projectsEntryAPI.generateDoc(body);
    return res?.data;
  } catch (e) { }
};
export const downloadDoc = async (body) => {
  try {
    const res = await projectsEntryAPI.downloadDoc(body);
    return res?.data;
  } catch (e) { }
};
export const deleteDoc = async (project_agreement_id) => {
  try {
    const res = await projectsEntryAPI.deleteDoc(project_agreement_id);
    return res?.data;
  } catch (e) { }
};
export const putSBSProject = async (body) => {
  try {
    const res = await projectsEntryAPI.putSBSProject(body);
    return res?.data;
  } catch (e) { }
};
export const getResidencyOptions = async () => {
  try {
    const res = await projectsEntryAPI.getResidents();
    return res?.residents;
  } catch (e) { }
};
export const getEntrances = async (resident_id, params) => {
  try {
    const res = await projectsEntryAPI.getEntrances(resident_id, params);
    return res?.data;
  } catch (e) { }
};
export const getAvailableEntrances = async (params) => {
  try {
    const res = await projectsEntryAPI.getAvailableEntrances(params);
    return res?.data;
  } catch (e) { }
};
export const updateProjectEntrance = async (body, params) => {
  try {
    const res = await projectsEntryAPI.updateProjectEntrance(body, params);
    return res?.data;
  } catch (e) { }
};
export const getResidentDetailedInfo = async (params, options = {}) => {
  try {
    const requestConfig = options.silent ? { _skipErrorToast: true } : {};
    const res = await projectsEntryAPI.getResidentDetailedInfo(params, requestConfig);
    return res?.data;
  } catch (e) {
    if (!options.silent) throw e;
  }
};
export const setProjectIsPreorder = async (body, params) => {
  try {
    const res = await projectsEntryAPI.setProjectIsPreorder(body);
    return res?.data;
  } catch (e) { }
};
export const setProjectIsSmetaConfirm = async (body, params) => {
  try {
    const res = await projectsEntryAPI.setProjectIsSmetaConfirm(body);
    return res;
  } catch (e) { }
};
export const getProjectSmeta = async (projectId) => {
  try {
    const res = await projectsEntryAPI.getProjectSmeta(projectId);
    return res?.data;
  } catch (e) { }
};
export const getProjectEntranceSmeta = async (projectId, entrance) => {
  if (!entrance) return;
  try {
    const res = await projectsEntryAPI.getProjectEntranceSmeta(
      projectId,
      entrance
    );
    return res?.data?.map((item, i) => ({ ...item, index: i + 1 }));
  } catch (e) { }
};
export const getProjectFloorSmeta = async (projectId, entrance, floor) => {
  if (!entrance || !floor) return;
  try {
    const res = await projectsEntryAPI.getProjectFloorSmeta(
      projectId,
      entrance,
      floor
    );
    return res?.data?.map((item, i) => ({ ...item, index: i + 1 }));
  } catch (e) { }
};
export const updateProjectMaterial = async (body) => {
  try {
    const res = await projectsEntryAPI.updateProjectMaterial(body);
    return res?.data;
  } catch (e) { }
};

export const getProjectMaterials = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getProjectMaterials(project_id);
    return res?.data;
  } catch (e) { }
};

export const getResortMaterials = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getResortMaterials(project_id);
    return res?.data;
  } catch (e) {}
};

export const resortMaterialSearch = async (params) => {
  try {
    const res = await projectsEntryAPI.resortMaterialSearch(params);
    return res?.data;
  } catch (e) {}
};

export const resortMaterialUpd = async (body) => {
  const res = await projectsEntryAPI.resortMaterialUpd(body);
  return res?.data;
};

export const getProjectEntrances = async (project_id) => {
  if (!project_id) return;
  try {
    const res = await projectsEntryAPI.getProjectEntrances(project_id);
    return res?.data?.map((item) => ({
      ...item,
      label: `Подъезд ${item.entrance}`,
    }));
  } catch (e) { }
};
export const getProjectEntranceFloors = async (project_id, entrance) => {
  if (!entrance) return;
  try {
    const res = await projectsEntryAPI.getProjectEntranceFloors(
      project_id,
      entrance
    );
    return res?.data?.map((item) => ({
      ...item,
      label: `Этаж ${item.level_num}`,
    }));
  } catch (e) { }
};

export const createProjectFloor = async (body) => {
  try {
    const res = await projectsEntryAPI.addProjectFloor(body);
    return res?.data;
  } catch (e) { }
};

export const deleteProjectFloor = async (floor_map_id, params) => {
  try {
    const res = await projectsEntryAPI.deleteProjectFloor(floor_map_id, params);
    return res?.data;
  } catch (e) { }
};

export const getProjectList = async (params = {}) => {
  try {
    const res = await projectsEntryAPI.getProjectList(params);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getProjectsForTransfer = async (project_id, params = {}) => {
  try {
    const res = await projectsEntryAPI.getProjectsForTransfer(project_id, params);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const copyFloorToProject = async (floor_map_id, body) => {
  const res = await projectsEntryAPI.copyFloorToProject(floor_map_id, body);
  return res;
};

export const updateWorksetProject = async (body) => {
  try {
    const res = await projectsEntryAPI.updateWorksetProject(body);
    return res?.data;
  } catch (e) { }
};

export const recalcSmeta = async (project_id, reason_code, comments = null) => {
  try {
    const res = await projectsEntryAPI.recalcSmeta(
      project_id,
      reason_code,
      comments
    );
    return res?.status;
  } catch (e) { }
};

export const getSmetaChangeReasons = async () => {
  try {
    const res = await projectsEntryAPI.getSmetaChangeReasons();
    return res?.data;
  } catch (e) { }
};

export const getFlatWorkSets = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getFlatWorkSets(project_id);
    return res?.data;
  } catch (e) { }
};

export const getFlatMaterials = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getFlatMaterials(project_id);
    return res?.data;
  } catch (e) { }
};

export const recalcProjectMaterialPrices = async (body) => {
  try {
    const res = await projectsEntryAPI.recalcProjectMaterialPrices(body);
    return res?.status;
  } catch (e) { }
};

export const getSmetaVersions = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getSmetaVersions(project_id);
    return res?.data;
  } catch (e) { }
};

export const getSmetaDiffWork = async (
  project_id,
  smeta_version_id1,
  smeta_version_id2,
  filters = {}
) => {
  try {
    const res = await projectsEntryAPI.getSmetaDiffWork(
      project_id,
      smeta_version_id1,
      smeta_version_id2,
      filters
    );
    return res?.data;
  } catch (e) { }
};

export const getSmetaDiffMaterial = async (
  project_id,
  smeta_version_id1,
  smeta_version_id2,
  filters = {}
) => {
  try {
    const res = await projectsEntryAPI.getSmetaDiffMaterial(
      project_id,
      smeta_version_id1,
      smeta_version_id2,
      filters
    );
    return res?.data;
  } catch (e) { }
};

export const getSmetaRestoreCompare = async (
  project_id,
  smeta_version_id,
  project_entrance_id = null,
  floor_map_id = null,
  what = "general"
) => {
  try {
    if (!project_id || !smeta_version_id) return [];
    const params = { smeta_version_id, what: what || "general" };
    if (project_entrance_id) params.project_entrance_id = project_entrance_id;
    if (floor_map_id) params.floor_map_id = floor_map_id;
    const res = await projectsEntryAPI.getSmetaRestoreCompare(project_id, params);
    return res?.data || [];
  } catch (e) {
    console.error("smeta_restore_compare:", e);
    return [];
  }
};

export const postSmetaRestoreCompareUpd = async (
  project_id,
  smeta_version_id,
  items,
  project_entrance_id = null,
  floor_map_id = null
) => {
  try {
    const body = { smeta_version_id, items };
    if (project_entrance_id) body.project_entrance_id = project_entrance_id;
    if (floor_map_id) body.floor_map_id = floor_map_id;
    const res = await projectsEntryAPI.postSmetaRestoreCompareUpd(project_id, body);
    return res;
  } catch (e) {
    console.error("smeta_restore_compare_upd:", e);
    throw e;
  }
};

export const getSmetaCompareNewReport = async (
  project_id,
  smeta_version_id1,
  smeta_version_id2,
  project_entrance_id = null,
  floor_map_id = null
) => {
  try {
    if (!project_id) return [];

    const params = {
      smeta_version_id1,
      smeta_version_id2,
    };
    if (project_entrance_id) params.project_entrance_id = project_entrance_id;
    if (floor_map_id) params.floor_map_id = floor_map_id;

    const res = await projectsEntryAPI.getSmetaCompareNewReport(project_id, params);
    const rows = res?.data || [];

    // Группируем по подъезду + этажу + виду работы
    const workAgg = new Map();

    rows.forEach((row) => {
      const key = `${row.entrance || ""}_${row.level_num ?? ""}_${row.work_set_id || ""}`;
      let g = workAgg.get(key);
      if (!g) {
        g = {
          entrance: row.entrance,
          level_num: row.level_num,
          floor_map_id: row.floor_map_id,
          project_entrance_id: row.project_entrance_id,
          work_set_id: row.work_set_id,
          work_set_check_group_id: row.work_set_check_group_id,
          work_set_check_group_name: row.work_set_check_group_name,
          group_order_num: row.group_order_num,
          work_set_name: row.work_set_name,
          work_set_unit_name: row.work_set_unit_name,
          work_amount_v1: Number(row.work_amount_v1 || 0),
          work_sum_v1: Number(row.work_sum_v1 || 0),
          work_amount_v2: Number(row.work_amount_v2 || 0),
          work_sum_v2: Number(row.work_sum_v2 || 0),
          total_material_sum_v1: 0,
          total_material_sum_v2: 0,
          rowsCount: 0,
        };
        workAgg.set(key, g);
      }
      g.total_material_sum_v1 += Number(row.material_sum_v1 || 0);
      g.total_material_sum_v2 += Number(row.material_sum_v2 || 0);
      g.rowsCount += 1;
    });

    for (const g of workAgg.values()) {
      g.total_material_sum_v1 = Math.round(g.total_material_sum_v1 * 100) / 100;
      g.total_material_sum_v2 = Math.round(g.total_material_sum_v2 * 100) / 100;
      g.grand_total_sum_v1 = Math.round((g.work_sum_v1 + g.total_material_sum_v1) * 100) / 100;
      g.grand_total_sum_v2 = Math.round((g.work_sum_v2 + g.total_material_sum_v2) * 100) / 100;
      g._seen = false;
    }

    const sorted = [...rows].sort((a, b) => {
      const entranceA = Number(a.entrance || 0);
      const entranceB = Number(b.entrance || 0);
      if (entranceA !== entranceB) return entranceA - entranceB;

      const levelA = Number(a.level_num ?? 0);
      const levelB = Number(b.level_num ?? 0);
      if (levelA !== levelB) return levelA - levelB;

      const groupOrderA = Number(a.group_order_num ?? 9999);
      const groupOrderB = Number(b.group_order_num ?? 9999);
      if (groupOrderA !== groupOrderB) return groupOrderA - groupOrderB;

      const groupNameA = String(a.work_set_check_group_name || "");
      const groupNameB = String(b.work_set_check_group_name || "");
      if (groupNameA !== groupNameB) return groupNameA.localeCompare(groupNameB, "ru");

      const wnameA = String(a.work_set_name || "");
      const wnameB = String(b.work_set_name || "");
      if (wnameA !== wnameB) return wnameA.localeCompare(wnameB, "ru");

      const mnameA = String(a.material_name || "");
      const mnameB = String(b.material_name || "");
      return mnameA.localeCompare(mnameB, "ru");
    });

    let lastGroupKey = null;
    const result = [];

    sorted.forEach((item) => {
      const key = `${item.entrance || ""}_${item.level_num ?? ""}_${item.work_set_id || ""}`;
      const g = workAgg.get(key);
      const isFirst = !g._seen;
      if (isFirst) g._seen = true;

      const groupKey = `${item.entrance || ""}_${item.level_num ?? ""}_${item.work_set_check_group_id ?? ""}`;
      if (isFirst && groupKey !== lastGroupKey) {
        lastGroupKey = groupKey;
        result.push({
          isGroupHeader: true,
          groupKey,
          work_set_check_group_id: item.work_set_check_group_id,
          work_set_check_group_name: item.work_set_check_group_name,
          entrance: item.entrance,
          level_num: item.level_num,
          floor_map_id: item.floor_map_id,
        });
      }

      result.push({
        ...item,
        groupKey: key,
        work_rowspan: isFirst ? g.rowsCount : 0,
        wname: isFirst ? g.work_set_name : "",
        wunt: isFirst ? g.work_set_unit_name : "",
        wqty_v1: isFirst ? g.work_amount_v1 : null,
        wsum_v1: isFirst ? g.work_sum_v1 : null,
        wqty_v2: isFirst ? g.work_amount_v2 : null,
        wsum_v2: isFirst ? g.work_sum_v2 : null,
        ttl_v1: isFirst ? g.grand_total_sum_v1 : null,
        ttl_v2: isFirst ? g.grand_total_sum_v2 : null,
        mname: item.material_name,
        munt: item.material_unit_name,
        mqty_v1: Number(item.material_amount_v1 || 0),
        msum_v1: Number(item.material_sum_v1 || 0),
        mqty_v2: Number(item.material_amount_v2 || 0),
        msum_v2: Number(item.material_sum_v2 || 0),
      });
    });

    return result;
  } catch (e) {
    return [];
  }
};

export const getSmetaAgreementVersions = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getSmetaAgreementVersions(project_id);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getSmetaAgreementHistoryCompareRaw = async (
  project_id,
  smeta_version_id1,
  smeta_version_id2,
) => {
  try {
    if (!project_id) return [];
    const params = { smeta_version_id1, smeta_version_id2 };
    const res = await projectsEntryAPI.getSmetaAgreementHistoryCompare(project_id, params);
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

export const getSmetaAgreementHistoryCompare = async (
  project_id,
  smeta_version_id1,
  smeta_version_id2,
) => {
  try {
    if (!project_id) return [];

    const params = { smeta_version_id1, smeta_version_id2 };
    const res = await projectsEntryAPI.getSmetaAgreementHistoryCompare(project_id, params);
    const rows = res?.data || [];

    // Группируем по подъезду + этажу + виду работы (аналогично getSmetaCompareNewReport)
    const workAgg = new Map();

    rows.forEach((row) => {
      const key = `${row.entrance || ''}_${row.level_num ?? ''}_${row.work_set_id || ''}`;
      let g = workAgg.get(key);
      if (!g) {
        g = {
          entrance: row.entrance,
          level_num: row.level_num,
          floor_map_id: row.floor_map_id,
          project_entrance_id: row.project_entrance_id,
          work_set_id: row.work_set_id,
          work_set_check_group_id: row.work_set_check_group_id,
          work_set_check_group_name: row.work_set_check_group_name,
          group_order_num: row.group_order_num,
          work_set_name: row.work_set_name,
          work_set_unit_name: row.work_set_unit_name,
          work_amount_v1: Number(row.work_amount_v1 || 0),
          work_sum_v1: Number(row.work_sum_v1 || 0),
          work_amount_v2: Number(row.work_amount_v2 || 0),
          work_sum_v2: Number(row.work_sum_v2 || 0),
          total_material_sum_v1: 0,
          total_material_sum_v2: 0,
          rowsCount: 0,
        };
        workAgg.set(key, g);
      }
      g.total_material_sum_v1 += Number(row.material_sum_v1 || 0);
      g.total_material_sum_v2 += Number(row.material_sum_v2 || 0);
      g.rowsCount += 1;
    });

    for (const g of workAgg.values()) {
      g.total_material_sum_v1 = Math.round(g.total_material_sum_v1 * 100) / 100;
      g.total_material_sum_v2 = Math.round(g.total_material_sum_v2 * 100) / 100;
      g.grand_total_sum_v1 = Math.round((g.work_sum_v1 + g.total_material_sum_v1) * 100) / 100;
      g.grand_total_sum_v2 = Math.round((g.work_sum_v2 + g.total_material_sum_v2) * 100) / 100;
      g._seen = false;
    }

    const sorted = [...rows].sort((a, b) => {
      const ea = Number(a.entrance || 0), eb = Number(b.entrance || 0);
      if (ea !== eb) return ea - eb;
      const la = Number(a.level_num ?? 0), lb = Number(b.level_num ?? 0);
      if (la !== lb) return la - lb;
      const ga = Number(a.group_order_num ?? 9999), gb = Number(b.group_order_num ?? 9999);
      if (ga !== gb) return ga - gb;
      const gna = String(a.work_set_check_group_name || ''), gnb = String(b.work_set_check_group_name || '');
      if (gna !== gnb) return gna.localeCompare(gnb, 'ru');
      const wna = String(a.work_set_name || ''), wnb = String(b.work_set_name || '');
      if (wna !== wnb) return wna.localeCompare(wnb, 'ru');
      return String(a.material_name || '').localeCompare(String(b.material_name || ''), 'ru');
    });

    let lastGroupKey = null;
    const result = [];

    sorted.forEach((item) => {
      const key = `${item.entrance || ''}_${item.level_num ?? ''}_${item.work_set_id || ''}`;
      const g = workAgg.get(key);
      const isFirst = !g._seen;
      if (isFirst) g._seen = true;

      const groupKey = `${item.entrance || ''}_${item.level_num ?? ''}_${item.work_set_check_group_id ?? ''}`;
      if (isFirst && groupKey !== lastGroupKey) {
        lastGroupKey = groupKey;
        result.push({
          isGroupHeader: true,
          groupKey,
          work_set_check_group_id: item.work_set_check_group_id,
          work_set_check_group_name: item.work_set_check_group_name,
          entrance: item.entrance,
          level_num: item.level_num,
          floor_map_id: item.floor_map_id,
        });
      }

      result.push({
        ...item,
        groupKey: key,
        work_rowspan: isFirst ? g.rowsCount : 0,
        wname: isFirst ? g.work_set_name : '',
        wunt: isFirst ? g.work_set_unit_name : '',
        wqty_v1: isFirst ? g.work_amount_v1 : null,
        wsum_v1: isFirst ? g.work_sum_v1 : null,
        wqty_v2: isFirst ? g.work_amount_v2 : null,
        wsum_v2: isFirst ? g.work_sum_v2 : null,
        ttl_v1: isFirst ? g.grand_total_sum_v1 : null,
        ttl_v2: isFirst ? g.grand_total_sum_v2 : null,
        mname: item.material_name,
        munt: item.material_unit_name,
        mqty_v1: Number(item.material_amount_v1 || 0),
        msum_v1: Number(item.material_sum_v1 || 0),
        mqty_v2: Number(item.material_amount_v2 || 0),
        msum_v2: Number(item.material_sum_v2 || 0),
      });
    });

    return result;
  } catch (e) {
    return [];
  }
};

export const getProjectDocs = async (params) => {
  try {
    const res = await projectsEntryAPI.getProjectDocs(params);
    return res?.data;
  } catch (e) { }
};

export const getProjectDocTypes = async () => {
  try {
    const res = await projectsEntryAPI.getProjectDocTypes();
    return res?.data;
  } catch (e) { }
};

export const addProjectDocument = async (body, project_id) => {
  try {
    const res = await projectsEntryAPI.addProjectDocument(body, project_id);
    return res?.data;
  } catch (e) { }
};

export const signDocuments = async (body) => {
  try {
    const res = await projectsEntryAPI.signDocument(body);
    return res?.data;
  } catch (e) { }
};

export const deleteDocument = async (project_document_id, params) => {
  try {
    const res = await projectsEntryAPI.deleteDocument(
      project_document_id,
      params
    );
    return res?.data;
  } catch (e) { }
};
export const downloadProjectDocumentPDF = async (
  project_document_id,
  fileName
) => {
  const { downloadFile } = await import("@/services");
  const url = `/project_list/project/document/sign/download/`;
  await downloadFile(
    url,
    fileName,
    { project_document_id },
    "pdf",
    "post",
    true
  );
};

export const loadRevitProject = async (body) => {
  try {
    const res = await projectsEntryAPI.loadRevitProject(body);
    return res?.data;
  } catch (e) { }
};

export const createDS = async (body) => {
  try {
    await projectsEntryAPI.createDS(body);
    return true;
  } catch (e) { }
};

/**
 * Скачать отчёт ДДУ. Возвращает { has_data: false, message } или { has_data: true, blob, filename }.
 */
export const downloadDduReport = async (resident_id, date_from, date_to) => {
  try {
    const response = await projectsEntryAPI.dduDownload({
      resident_id,
      date_from,
      date_to,
    });
    const ct = (response.headers && response.headers["content-type"]) || "";
    if (ct.indexOf("json") !== -1) {
      const text = await response.data.text();
      const data = JSON.parse(text);
      return {
        has_data: false,
        message: data.message || "Нет данных за выбранный период",
      };
    }
    let filename = "DDU.xlsx";
    const disp = response.headers && response.headers["content-disposition"];
    if (disp) {
      const mUtf8 = disp.match(/filename\*=UTF-8''([^;]+)/i);
      if (mUtf8) {
        filename = decodeURIComponent(mUtf8[1]);
      } else {
        const m = disp.match(/filename="?([^";]+)"?/);
        if (m) filename = m[1];
      }
    }
    return { has_data: true, blob: response.data, filename };
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try {
        const text = await blob.text();
        const data = JSON.parse(text);
        return { has_data: false, message: data.error || data.message || "Ошибка при формировании ДДУ" };
      } catch {}
    }
    return null;
  }
};

export const agreementCancel = async (body) => {
  try {
    const res = await projectsEntryAPI.agreementCancel(body);
    return res?.data;
  } catch (e) {}
};

export const duplicateProjectAssign = async (body) => {
  try {
    const res = await projectsEntryAPI.duplicateProjectAssign(body);
    return res;
  } catch (e) {}
};
export const getEntrancesByProject = async (project_id) => {
  try {
    const res = await projectsEntryAPI.getEntrancesByProject({ project_id });
    return (
      res?.data?.map((item) => ({
        ...item,
        entrance_name: `Подъезд ${item.entrance}${
          item.block_name ? `, Блок ${item.block_name}` : ""
        }`,
      })) || []
    );
  } catch (e) {
    console.error("Error loading entrances:", e);
    return [];
  }
};

export const getBimDigitalParamCompare = async (params) => {
  try {
    const res = await projectsEntryAPI.getBimDigitalParamCompare(params);
    return res;
  } catch (e) {
    console.error("bim_digital_param_compare:", e);
    throw e;
  }
};

export const getDigitalSmetaCompare = async (params) => {
  try {
    const res = await projectsEntryAPI.getDigitalSmetaCompare(params);
    return res;
  } catch (e) {
    console.error("digital_smeta_compare:", e);
    throw e;
  }
};

export const getSbsProjectList = async () => {
  try {
    const res = await projectsEntryAPI.getSbsProjectList();
    return res?.data;
  } catch (e) {
    console.error("Error loading SBS projects:", e);
    return [];
  }
};

export const getSbsProjectListForModal = async () => {
  try {
    const res = await projectsEntryAPI.getSbsProjectListForModal();
    return res?.data;
  } catch (e) {
    console.error("Error loading SBS projects for modal:", e);
    return [];
  }
};

export const getProjectSmetaNew = async (
  project_id,
  project_entrance_id,
  what,
  floor_map_id = null,
  work_set_ids = null
) => {
  try {
    if (!project_id) return [];

    const params = {
      project_id,
    };

    if (project_entrance_id) {
      params.project_entrance_id = project_entrance_id;
    }

    if (what) {
      params.what = what;
    }

    if (floor_map_id) {
      params.floor_map_id = floor_map_id;
    }

    if (Array.isArray(work_set_ids) && work_set_ids.length > 0) {
      params.work_set_ids = work_set_ids.join(",");
    }

    const res = await projectsEntryAPI.getProjectSmetaNew(params);
    const rows = res?.data || [];

    // Группируем по подъезду + этажу + группе проверки + виду работы
    // (entrance + level_num + work_set_check_group_id + work_set_id)
    // Важно: один и тот же work_set_id может фигурировать в разных группах
    // (например, оригинальная группа + «Доп работы N», если по ней увеличили кол-во при наличии АВР).
    // Без work_set_check_group_id такие конструктивы схлопывались в один и визуально «прилипали»
    // к чужому заголовку группы.
    const workAgg = new Map();

    rows.forEach((row) => {
      const key = `${row.entrance || ""}_${row.level_num ?? ""}_${row.work_set_check_group_id ?? ""}_${row.work_set_id || ""}`;
      let g = workAgg.get(key);

      if (!g) {
        g = {
          entrance: row.entrance,
          level_num: row.level_num,
          work_set_id: row.work_set_id,
          work_set_check_group_id: row.work_set_check_group_id,
          work_set_check_group_name: row.work_set_check_group_name,
          group_order_num: row.group_order_num,
          work_set_name: row.work_set_name,
          work_set_unit_name: row.work_set_unit_name,
          total_work_amount: Number(row.total_work_amount || 0),
          total_work_price: Number(row.total_work_price || 0),
          total_work_sum: Number(row.total_work_sum || 0),
          total_work_price_without_nds: Number(row.total_work_price_without_nds || 0),
          total_work_sum_without_nds: Number(row.total_work_sum_without_nds || 0),
          total_material_sum: 0,
          total_material_sum_without_nds: 0,
          is_include_nds_work_set: row.is_include_nds_work_set,
          nds_percent_work_set: row.nds_percent_work_set,
          // АВР / НУ / ОКК / Оплаты берём из первой строки (значения одинаковы для всего конструктива)
          avr_count: Number(row.avr_count || 0),
          avr_call_sum: Number(row.avr_call_sum || 0),
          has_foreman_call: row.has_foreman_call || false,
          foreman_call_date: row.foreman_call_date || null,
          is_foreman_checked: row.is_foreman_checked || false,
          has_okk_call: row.has_okk_call || false,
          okk_call_date: row.okk_call_date || null,
          is_okk_checked: row.is_okk_checked || false,
          paid_total: Number(row.paid_total || 0),
          rowsCount: 0,
        };
        workAgg.set(key, g);
      }

      g.total_material_sum += Number(row.total_material_sum || 0);
      g.total_material_sum_without_nds += Number(row.total_material_sum_without_nds || 0);
      g.rowsCount += 1;
    });

    // Считаем общий итог по конструктиву
    for (const g of workAgg.values()) {
      g.grand_total_sum =
        Number(g.total_work_sum || 0) + Number(g.total_material_sum || 0);
      g.grand_total_sum_without_nds =
        Number(g.total_work_sum_without_nds || 0) + Number(g.total_material_sum_without_nds || 0);
      g._seen = false;
    }

    // Сортируем: подъезд → этаж → группа (order_num) → доп-работы после исходной → конструктив → материал
    const sorted = [...rows].sort((a, b) => {
      const entranceA = Number(a.entrance || 0);
      const entranceB = Number(b.entrance || 0);
      if (entranceA !== entranceB) return entranceA - entranceB;

      const levelA = Number(a.level_num ?? 0);
      const levelB = Number(b.level_num ?? 0);
      if (levelA !== levelB) return levelA - levelB;

      const groupOrderA = Number(a.group_order_num ?? 9999);
      const groupOrderB = Number(b.group_order_num ?? 9999);
      if (groupOrderA !== groupOrderB) return groupOrderA - groupOrderB;

      // При равном group_order_num доп-группы (ADD_WORK) идут после своей исходной группы
      const isAddWorkA = a.source_work_set_check_group_id != null ? 1 : 0;
      const isAddWorkB = b.source_work_set_check_group_id != null ? 1 : 0;
      if (isAddWorkA !== isAddWorkB) return isAddWorkA - isAddWorkB;

      const groupNameA = String(a.work_set_check_group_name || "");
      const groupNameB = String(b.work_set_check_group_name || "");
      if (groupNameA !== groupNameB) return groupNameA.localeCompare(groupNameB, "ru");

      const wnameA = String(a.work_set_name || "");
      const wnameB = String(b.work_set_name || "");
      if (wnameA !== wnameB) return wnameA.localeCompare(wnameB, "ru");

      const mnameA = String(a.material_name || "");
      const mnameB = String(b.material_name || "");
      return mnameA.localeCompare(mnameB, "ru");
    });

    let index = 1;
    let lastGroupKey = null;
    const result = [];

    sorted.forEach((item) => {
      const key = `${item.entrance || ""}_${item.level_num ?? ""}_${item.work_set_check_group_id ?? ""}_${item.work_set_id || ""}`;
      const g = workAgg.get(key);
      const isFirst = !g._seen;
      if (isFirst) {
        g._seen = true;
        g.index = index++;
      }

      // Вставляем заголовочную строку группы при смене группы
      const groupKey = `${item.entrance || ""}_${item.level_num ?? ""}_${item.work_set_check_group_id ?? ""}`;
      if (isFirst && groupKey !== lastGroupKey) {
        lastGroupKey = groupKey;
        result.push({
          isGroupHeader: true,
          groupKey: groupKey,
          work_set_check_group_id: item.work_set_check_group_id,
          work_set_check_group_name: item.work_set_check_group_name,
          entrance: item.entrance,
          level_num: item.level_num,
          floor_map_id: item.floor_map_id,
        });
      }

      result.push({
        ...item,
        index: g.index,
        groupKey: key,
        // Конструктив показываем только в первой строке группы
        work_rowspan: isFirst ? g.rowsCount : 0,
        wname: isFirst ? g.work_set_name : "",
        wunt: isFirst ? g.work_set_unit_name : "",
        wqty: isFirst ? g.total_work_amount : null,
        wprc: isFirst ? g.total_work_price : null,
        wsum: isFirst ? g.total_work_sum : null,
        wprc_no_nds: isFirst ? g.total_work_price_without_nds : null,
        wsum_no_nds: isFirst ? g.total_work_sum_without_nds : null,
        // Материалы показываем всегда построчно
        mname: item.material_name,
        munt: item.material_unit_name,
        munc: item.material_unit_code || "",
        mqty: item.total_material_amount,
        mprc: item.total_material_price,
        msum: item.total_material_sum,
        mprc_no_nds: Number(item.total_material_price_without_nds || 0),
        msum_no_nds: Number(item.total_material_sum_without_nds || 0),
        // Норма расхода: кол-во материала на единицу работы
        orig_wqty: g.total_work_amount,
        norm_ratio: g.total_work_amount > 0 ? item.total_material_amount / g.total_work_amount : 0,
        // Общий итог только в первой строке конструктивной группы
        ttl: isFirst ? g.grand_total_sum : null,
        ttl_no_nds: isFirst ? g.grand_total_sum_without_nds : null,
        // НДС по материалам - как в строке
        is_incloude_nds_material: item.is_include_nds_material,
        nds_percent_material: item.nds_percent_material,
        // НДС по работе показываем только в первой строке
        is_incloude_nds_work_set: isFirst ? g.is_include_nds_work_set : 0,
        nds_percent_work_set: isFirst ? g.nds_percent_work_set : null,
        // АВР / НУ / ОКК / Оплаты — только в первой строке конструктива
        avr_count: isFirst ? g.avr_count : null,
        avr_call_sum: isFirst ? g.avr_call_sum : null,
        has_foreman_call: isFirst ? g.has_foreman_call : null,
        foreman_call_date: isFirst ? g.foreman_call_date : null,
        is_foreman_checked: isFirst ? g.is_foreman_checked : null,
        has_okk_call: isFirst ? g.has_okk_call : null,
        okk_call_date: isFirst ? g.okk_call_date : null,
        is_okk_checked: isFirst ? g.is_okk_checked : null,
        paid_total: isFirst ? g.paid_total : null,
      });
    });

    return result;
  } catch (e) {
    console.error("Error loading new smeta report:", e);
    return [];
  }
};

/** Сырые строки сметы по ЖК (без клиентской агрегации). */
/** Блоки/подъезды ЖК для фильтра сметы (block_name, entrance из project_entrance_tab). */
export const getResidentSmetaBlockOptions = async (
  resident_id,
  project_type_id = null
) => {
  try {
    if (!resident_id) return [];

    const params = { resident_id };
    if (
      project_type_id != null &&
      project_type_id !== "" &&
      Number(project_type_id) !== 0
    ) {
      params.project_type_id = project_type_id;
    }

    const list = await getResidentialEntrances(params);
    if (!Array.isArray(list)) return [];

    return list
      .filter((item) => item?.project_entrance_id != null)
      .map((item) => ({
        ...item,
        label: formatResidentSmetaBlockEntranceLabel(item),
        value: item.project_entrance_id,
      }))
      .sort((a, b) => String(a.label).localeCompare(String(b.label), "ru"));
  } catch (e) {
    console.error("Error loading resident smeta block options:", e);
    return [];
  }
};

function normalizeFloorMapReadPayload(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  return [];
}

function mapFloorMapRowsToOptions(rows) {
  const seen = new Set();
  return (rows || [])
    .filter((item) => item?.floor_map_id != null)
    .map((item) => {
      const levelNum = item.level_num ?? item.floor;
      return {
        ...item,
        level_num: levelNum,
        value: item.floor_map_id,
        label: `Этаж ${levelNum ?? "—"}`,
      };
    })
    .filter((item) => {
      if (seen.has(item.value)) return false;
      seen.add(item.value);
      return true;
    })
    .sort((a, b) => Number(a.level_num ?? 0) - Number(b.level_num ?? 0));
}

async function loadFloorMapOptionsForEntrance(project_entrance_id, scope = {}) {
  const res = await projectsEntryAPI.getFloorMapByEntrance({
    project_entrance_id,
  });
  let options = mapFloorMapRowsToOptions(normalizeFloorMapReadPayload(res));

  if (!options.length && scope.resident_id) {
    const raw = await fetchResidentSmetaNewRaw(
      scope.resident_id,
      scope.project_type_id ?? null,
      project_entrance_id
    );
    options = buildResidentSmetaFloorOptionsFromRaw(raw, { project_entrance_id });
  }

  return options;
}

/**
 * Этажи для фильтра сметы: floor_map_id + level_num из floor_map_tab.
 * entrance_floors/read отдаёт только level_num (для buffer) — для сметы используем floor_map/read.
 */
export const getResidentSmetaFloorOptions = async ({
  resident_id,
  project_type_id = null,
  project_entrance_id = null,
  project_entrance_ids = null,
} = {}) => {
  try {
    if (!resident_id) return [];

    const scope = {
      resident_id,
      project_type_id,
    };

    if (project_entrance_id) {
      return await loadFloorMapOptionsForEntrance(project_entrance_id, scope);
    }

    const entranceIds = Array.isArray(project_entrance_ids)
      ? project_entrance_ids.filter((id) => id != null && id !== "")
      : [];

    if (!entranceIds.length) {
      return [];
    }

    const chunks = await Promise.all(
      entranceIds.map((id) => loadFloorMapOptionsForEntrance(id, scope))
    );
    const merged = chunks.flat();
    const seen = new Set();
    return merged.filter((item) => {
      if (seen.has(item.value)) return false;
      seen.add(item.value);
      return true;
    });
  } catch (e) {
    console.error("Error loading resident smeta floor options:", e);
    return [];
  }
};

function buildResidentSmetaScopeParams({
  resident_id,
  project_type_id = null,
  project_entrance_id = null,
  floor_map_id = null,
} = {}) {
  const params = { resident_id };
  if (
    project_type_id != null &&
    project_type_id !== "" &&
    Number(project_type_id) !== 0
  ) {
    params.project_type_id = project_type_id;
  }
  if (project_entrance_id) {
    params.project_entrance_id = project_entrance_id;
  }
  if (floor_map_id) {
    params.floor_map_id = floor_map_id;
  }
  return params;
}

export const exportResidentSmetaNewReport = async ({
  resident_id,
  project_type_id = null,
  project_entrance_id = null,
  floor_map_id = null,
  work_set_check_group_id = null,
  work_set_id = null,
  material_id = null,
} = {}) => {
  if (!resident_id) return false;

  const params = buildResidentSmetaScopeParams({
    resident_id,
    project_type_id,
    project_entrance_id,
    floor_map_id,
  });

  if (work_set_check_group_id) {
    params.work_set_check_group_id = work_set_check_group_id;
  }
  if (work_set_id) {
    params.work_set_id = work_set_id;
  }
  if (material_id) {
    params.material_id = material_id;
  }

  const { downloadFile } = await import("@/services");
  const title = "Отчет Бюджет проекта";
  return downloadFile(
    "/project_list/project/smeta_resident_new_report/excel/",
    title,
    { params },
    "xlsx",
    "get",
    true
  );
};

export const fetchResidentSmetaNewRaw = async (
  resident_id,
  project_type_id = null,
  project_entrance_id = null,
  floor_map_id = null,
  work_set_check_group_id = null,
  work_set_id = null,
  material_id = null
) => {
  try {
    if (!resident_id) return [];

    const params = buildResidentSmetaScopeParams({
      resident_id,
      project_type_id,
      project_entrance_id,
      floor_map_id,
    });

    if (work_set_check_group_id) {
      params.work_set_check_group_id = work_set_check_group_id;
    }
    if (work_set_id) {
      params.work_set_id = work_set_id;
    }
    if (material_id) {
      params.material_id = material_id;
    }

    const res = await projectsEntryAPI.getResidentSmetaNew(params);
    return res?.data || [];
  } catch (e) {
    console.error("Error loading resident smeta report:", e);
    return [];
  }
};

/** Актуальная смета по всем проектам ЖК (один запрос к API). */
export const getResidentSmetaNew = async (
  resident_id,
  project_type_id = null,
  project_entrance_id = null,
  floor_map_id = null
) => {
  const rows = await fetchResidentSmetaNewRaw(
    resident_id,
    project_type_id,
    project_entrance_id,
    floor_map_id
  );
  return buildSmetaNewTableRows(rows, { withProjectKey: true });
};

export const updateSmetaNewWorkQty = async (body) => {
  try {
    const res = await projectsEntryAPI.updateSmetaNewWorkQty(body);
    if (res?.error) throw new Error(res.error);
    return res;
  } catch (e) {
    console.error("Error updating work qty:", e);
    throw e;
  }
};

export const updateSmetaNewMaterialQty = async (body) => {
  try {
    const res = await projectsEntryAPI.updateSmetaNewMaterialQty(body);
    if (res?.error) throw new Error(res.error);
    return res;
  } catch (e) {
    console.error("Error updating material qty:", e);
    throw e;
  }
};

export const getSmetaNewAvrList = async (params) => {
  try {
    const res = await projectsEntryAPI.getSmetaNewAvrList(params);
    return res?.data || [];
  } catch (e) {
    console.error('Error loading AVR list:', e);
    return [];
  }
};

export const getSmetaNewMaterialSearch = async (params) => {
  try {
    const res = await projectsEntryAPI.getSmetaNewMaterialSearch(params);
    return res?.data || [];
  } catch (e) {
    console.error('Error loading material search:', e);
    return [];
  }
};

export const getSmetaNewRefreshPricesPreview = async (params) => {
  const res = await projectsEntryAPI.getSmetaNewRefreshPricesPreview(params);
  return res?.data || [];
};

export const getSmetaNewWorkSetsByGroup = async (work_set_check_group_id, project_id) => {
  try {
    const params = { work_set_check_group_id };
    if (project_id) params.project_id = project_id;
    const res = await projectsEntryAPI.getSmetaNewWorkSetsByGroup(params);
    return res?.data || [];
  } catch (e) {
    console.error("Error loading work sets by group:", e);
    return [];
  }
};

export const getSmetaNewAvailableGroups = async (project_id, floor_map_id) => {
  try {
    const res = await projectsEntryAPI.getSmetaNewAvailableGroups({ project_id, floor_map_id });
    return res?.data || [];
  } catch (e) {
    console.warn('getSmetaNewAvailableGroups not available:', e?.message);
    return [];
  }
};

export const getSmetaNewWorkSetsInScope = async (
  project_id,
  project_entrance_id = null,
  floor_map_id = null
) => {
  try {
    if (!project_id) return [];
    const params = { project_id };
    if (project_entrance_id != null) params.project_entrance_id = project_entrance_id;
    if (floor_map_id != null) params.floor_map_id = floor_map_id;
    const res = await projectsEntryAPI.getSmetaNewWorkSetsInScope(params);
    return res?.data || [];
  } catch (e) {
    console.warn("getSmetaNewWorkSetsInScope:", e?.message);
    return [];
  }
};

/** Скоуп СМР с флагами блокировок (для multi-select обновления цен СМР). */
export const getSmetaNewRefreshSmrScope = async (
  project_id,
  project_entrance_id = null,
  floor_map_id = null,
  work_set_ids = null
) => {
  try {
    if (!project_id) return [];
    const params = { project_id };
    if (project_entrance_id) params.project_entrance_id = project_entrance_id;
    if (floor_map_id) params.floor_map_id = floor_map_id;
    if (Array.isArray(work_set_ids) && work_set_ids.length > 0) {
      params.work_set_ids = work_set_ids.join(",");
    }
    const res = await projectsEntryAPI.getSmetaNewRefreshSmrScope(params);
    return res?.data || [];
  } catch (e) {
    console.warn("getSmetaNewRefreshSmrScope:", e?.message);
    return [];
  }
};

/** Превью обновления цен ТМЦ команды проекта под текущие фильтры. */
export const getSmetaNewRefreshTmcPricesPreview = async (
  project_id,
  project_entrance_id = null,
  floor_map_id = null,
  work_set_ids = null
) => {
  if (!project_id) return [];
  const params = { project_id };
  if (project_entrance_id) params.project_entrance_id = project_entrance_id;
  if (floor_map_id) params.floor_map_id = floor_map_id;
  if (Array.isArray(work_set_ids) && work_set_ids.length > 0) {
    params.work_set_ids = work_set_ids.join(",");
  }
  const res = await projectsEntryAPI.getSmetaNewRefreshTmcPricesPreview(params);
  return res?.data || [];
};

/**
 * Список этажей проекта-кандидатов для «Скопировать на этажи».
 * Возвращает все этажи кроме исходного с флагом is_blocked + block_reason.
 * Заблокированные этажи фронт прячет в UI (контракт UX-задачи):
 *   - has_avr — на целевом этаже у копируемой work_set_id есть АВР/КС2В
 *     (по конкретной работе, как в таблице сметы, save_changes и bulk-обновлении цен),
 *   - has_process — на группе начат процесс приёмки,
 *   - has_oper_fact — на группе есть опер-факт,
 *   - already_exists — работа уже есть в этой группе на этом этаже
 *     (при material_id — материал уже есть в этой работе на этом этаже),
 *   - work_missing — только при material_id: работы на этаже нет, копировать
 *     материал некуда.
 *
 * @param {number|string} project_id
 * @param {number|string|null} source_floor_map_id  исходный этаж (исключаем)
 * @param {number|string} work_set_id
 * @param {number|string} work_set_check_group_id
 * @param {number|string|null} [material_id=null]  если задан — режим копии материала
 * @param {number|string|null} [purchase_type_id=null]  актуально только при
 *   копии материала. Если 2 (Команда проекта) — бэк не блокирует этажи по
 *   has_avr/has_process: такие ТМЦ можно копировать в работы с подписанным
 *   АВР/КС2В и идущим процессом приёмки.
 */
export const getSmetaNewFloorsForCopy = async (
  project_id,
  source_floor_map_id,
  work_set_id,
  work_set_check_group_id,
  material_id = null,
  purchase_type_id = null
) => {
  if (!project_id || !work_set_id || !work_set_check_group_id) return [];
  try {
    const params = {
      project_id,
      work_set_id,
      work_set_check_group_id,
    };
    if (source_floor_map_id) params.source_floor_map_id = source_floor_map_id;
    if (material_id !== null && material_id !== undefined && material_id !== "") {
      params.material_id = material_id;
    }
    if (purchase_type_id !== null && purchase_type_id !== undefined && purchase_type_id !== "") {
      params.purchase_type_id = purchase_type_id;
    }
    const res = await projectsEntryAPI.getSmetaNewFloorsForCopy(params);
    return res?.data || [];
  } catch (e) {
    console.warn("getSmetaNewFloorsForCopy:", e?.message);
    return [];
  }
};

export const getSmetaNewNdsPercent = async () => {
  try {
    const res = await projectsEntryAPI.getSmetaNewNdsPercent();
    return Number(res?.nds_percent || 0);
  } catch (e) {
    console.error('Error loading nds_percent:', e);
    return 0;
  }
};

/**
 * Обобщённое состояние проекта: флаги/списки для блокировок и подсказок на фронте.
 * Возвращает объект вида:
 *   {
 *     project_id,
 *     has_unsent_ds,
 *     unsent_ds_list: [...],
 *     ...дополнительные поля, которые бэк будет добавлять со временем
 *   }
 * Новые поля на фронте появятся автоматически — без новых эндпоинтов/сервисов.
 */
export const getProjectState = async (project_id) => {
  const empty = { project_id: null, has_unsent_ds: false, unsent_ds_list: [] };
  if (!project_id) return empty;
  try {
    const res = await projectsEntryAPI.getProjectState(project_id);
    return res?.data || empty;
  } catch (e) {
    console.error('Error loading project state:', e);
    return empty;
  }
};

export const saveSmetaNewChanges = async (body) => {
  try {
    const res = await projectsEntryAPI.saveSmetaNewChanges(body);
    if (!res || res?.error) return null;
    return res;
  } catch (e) {
    return null;
  }
};

export const getProjectSmetaMaterialReport = async (
  project_id,
  project_entrance_id,
  floor_map_id,
  purchase_type_id
) => {
  try {
    const params = { project_id };
    if (project_entrance_id) params.project_entrance_id = project_entrance_id;
    if (floor_map_id) params.floor_map_id = floor_map_id;
    if (purchase_type_id) params.purchase_type_id = purchase_type_id;

    const res = await projectsEntryAPI.getProjectSmetaMaterialReport(params);
    return res?.data;
  } catch (e) {
    console.error("Error loading material report:", e);
    return [];
  }
};

export const getProjectSmetaHistory = async (project_id, project_entrance_id, what = 'contractor') => {
  try {
    if (!project_id) return { rows: [], meta: null };

    const params = { project_id, what };
    if (project_entrance_id) params.project_entrance_id = project_entrance_id;

    const res = await projectsEntryAPI.getProjectSmetaHistory(params);
    const rows = res?.data || [];
    const meta = res?.meta || null;

    const workAgg = new Map();

    rows.forEach((row) => {
      const key = `${row.entrance || ''}_${row.level_num ?? ''}_${row.work_set_id || ''}`;
      let g = workAgg.get(key);
      if (!g) {
        g = {
          entrance: row.entrance,
          level_num: row.level_num,
          floor_map_id: row.floor_map_id,
          project_entrance_id: row.project_entrance_id,
          work_set_id: row.work_set_id,
          work_set_check_group_id: row.work_set_check_group_id,
          work_set_check_group_name: row.work_set_check_group_name,
          group_order_num: row.group_order_num,
          work_set_name: row.work_set_name,
          work_set_unit_name: row.work_set_unit_name,
          total_work_amount: Number(row.total_work_amount || 0),
          total_work_price: Number(row.total_work_price || 0),
          total_work_sum: Number(row.total_work_sum || 0),
          total_work_price_without_nds: Number(row.total_work_price_without_nds || 0),
          total_work_sum_without_nds: Number(row.total_work_sum_without_nds || 0),
          total_material_sum: 0,
          total_material_sum_without_nds: 0,
          is_include_nds_work_set: row.is_include_nds_work_set,
          nds_percent_work_set: row.nds_percent_work_set,
          rowsCount: 0,
        };
        workAgg.set(key, g);
      }
      g.total_material_sum += Number(row.total_material_sum || 0);
      g.total_material_sum_without_nds += Number(row.total_material_sum_without_nds || 0);
      g.rowsCount += 1;
    });

    for (const g of workAgg.values()) {
      g.grand_total_sum = Math.round((Number(g.total_work_sum || 0) + Number(g.total_material_sum || 0)) * 100) / 100;
      g.grand_total_sum_without_nds = Math.round((Number(g.total_work_sum_without_nds || 0) + Number(g.total_material_sum_without_nds || 0)) * 100) / 100;
      g._seen = false;
    }

    const sorted = [...rows].sort((a, b) => {
      if (Number(a.entrance || 0) !== Number(b.entrance || 0)) return Number(a.entrance || 0) - Number(b.entrance || 0);
      if (Number(a.level_num ?? 0) !== Number(b.level_num ?? 0)) return Number(a.level_num ?? 0) - Number(b.level_num ?? 0);
      if (Number(a.group_order_num ?? 9999) !== Number(b.group_order_num ?? 9999)) return Number(a.group_order_num ?? 9999) - Number(b.group_order_num ?? 9999);
      const gnA = String(a.work_set_check_group_name || '');
      const gnB = String(b.work_set_check_group_name || '');
      if (gnA !== gnB) return gnA.localeCompare(gnB, 'ru');
      if (Number(a.work_set_id || 0) !== Number(b.work_set_id || 0)) return Number(a.work_set_id || 0) - Number(b.work_set_id || 0);
      return String(a.material_name || '').localeCompare(String(b.material_name || ''), 'ru');
    });

    let lastGroupKey = null;
    const result = [];

    sorted.forEach((item) => {
      const key = `${item.entrance || ''}_${item.level_num ?? ''}_${item.work_set_id || ''}`;
      const g = workAgg.get(key);
      const isFirst = !g._seen;
      if (isFirst) g._seen = true;

      const groupKey = `${item.entrance || ''}_${item.level_num ?? ''}_${item.work_set_check_group_id ?? ''}`;
      if (isFirst && groupKey !== lastGroupKey) {
        lastGroupKey = groupKey;
        result.push({
          isGroupHeader: true,
          groupKey,
          work_set_check_group_id: item.work_set_check_group_id,
          work_set_check_group_name: item.work_set_check_group_name,
          entrance: item.entrance,
          level_num: item.level_num,
          floor_map_id: item.floor_map_id,
        });
      }

      result.push({
        ...item,
        groupKey: key,
        work_rowspan: isFirst ? g.rowsCount : 0,
        wname: isFirst ? g.work_set_name : '',
        wunt: isFirst ? g.work_set_unit_name : '',
        wqty: isFirst ? g.total_work_amount : null,
        wprc: isFirst ? g.total_work_price : null,
        wsum: isFirst ? g.total_work_sum : null,
        wprc_no_nds: isFirst ? g.total_work_price_without_nds : null,
        wsum_no_nds: isFirst ? g.total_work_sum_without_nds : null,
        mname: item.material_name,
        munt: item.material_unit_name,
        mqty: item.total_material_amount,
        mprc: item.total_material_price,
        msum: item.total_material_sum,
        mprc_no_nds: Number(item.total_material_price_without_nds || 0),
        msum_no_nds: Number(item.total_material_sum_without_nds || 0),
        norm_ratio: g.total_work_amount > 0 ? item.total_material_amount / g.total_work_amount : 0,
        ttl: isFirst ? g.grand_total_sum : null,
        ttl_no_nds: isFirst ? g.grand_total_sum_without_nds : null,
        is_incloude_nds_material: item.is_include_nds_material,
        nds_percent_material: item.nds_percent_material,
        is_incloude_nds_work_set: isFirst ? g.is_include_nds_work_set : 0,
        nds_percent_work_set: isFirst ? g.nds_percent_work_set : null,
      });
    });

    return { rows: result, meta };
  } catch (e) {
    console.error('Error loading smeta history report:', e);
    return { rows: [], meta: null };
  }
};

export const getSmetaAnomalies = async (
  project_id,
  date_from = null,
  date_to = null
) => {
  try {
    if (!project_id) return [];

    const params = { project_id };
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;

    const res = await projectsEntryAPI.getSmetaAnomalies(params);
    return res?.data || [];
  } catch (e) {
    console.error("Error loading smeta anomalies:", e);
    return [];
  }
};

export function getTextColorByBackground(hex) {
  hex = hex.replace("#", "");

  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  let brightness = 0.299 * r + 0.587 * g + 0.114 * b;

  return brightness > 186 ? "#000000" : "#FFFFFF";
}

export function getFillClass(is_filled) {
  if (+is_filled === 1) return "fill-yellow";
  if (+is_filled === 2) return "fill-green";
  return "";
}

export const projectsColumns = [
  {
    name: "resident_name",
    field: "resident_name",
    label: "ЖК",
    align: "left",
    headerStyle: "width: 200px",
    style: "width: 200px",
  },
  {
    name: "project_type_id",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
  {
    name: "naimenovanie",
    field: "naimenovanie",
    label: "Проект УСП",
    align: "left",
    headerStyle: "width: 180px",
    style: "width: 180px",
  },
  {
    name: "project_ids",
    field: "project_ids",
    label: "ID проектов",
    align: "center",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "block_names",
    field: "block_names",
    label: "Блоки",
    align: "center",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "min_start_date",
    field: "min_start_date",
    label: "Дата начала",
    align: "center",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
  {
    name: "max_finish_date",
    field: "max_finish_date",
    label: "Дата окончания",
    align: "center",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
];

export const selectedProjectsColumns = [
  {
    name: "project_id",
    field: "project_id",
    label: "ID",
    align: "center",
  },
  {
    name: "entrances",
    field: "entrances",
    label: "Подъезды",
    align: "center",
    headerStyle: "width: 100px",
    style: "width: 100px",
  },
  {
    name: "",
    field: "",
    label: "",
    align: "right",
  },
  {
    name: "start_date",
    field: "start_date",
    label: "Период / Исполнители",
    align: "center",
    headerStyle: "width: 140px",
    style: "width: 140px",
  },
  {
    name: "project_status_name",
    field: "project_status_name",
    label: "Этап",
    align: "center",
    headerStyle: "width: 220px",
    style: "width: 220px",
  },
  {
    name: "external_resource_code",
    field: "external_resource_code",
    label: "Тип / Аванс / НДС",
    align: "center",
    headerStyle: "width: 160px",
    style: "width: 160px",
  },
  {
    name: "is_preorder",
    field: "is_preorder",
    label: "Предзаказ / Смета",
    align: "center",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
  {
    name: "doc_info",
    field: "doc_info",
    label: "Договора",
    align: "left",
    headerStyle: "width: 250px",
    style: "width: 250px",
  },
  {
    name: "actions",
    field: "docactionsument",
    label: "Действие",
    align: "center",
  },
];

export const entrancesColumns = [
  {
    name: "project_entrance_id",
    field: "project_entrance_id",
    label: "ID",
    align: "left",
  },
  {
    name: "entrance",
    field: "entrance",
    label: "Подъезд",
    align: "left",
  },
  {
    name: "block_name",
    field: "block_name",
    label: "Блок",
    align: "center",
  },
];

export const performersColumns = [
  {
    name: "employee_fio",
    field: "employee_fio",
    label: "Исполнитель",
    align: "left",
  },
  {
    name: "assign_type_name",
    field: "assign_type_name",
    label: "Позиция",
    align: "left",
  },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Компания",
    align: "left",
  },
];

const tooltip = {
  backgroundColor: "#ffffff",
  buttonHoverColor: "#ffffff",
  textColor: "#373D48",
  tooltipClass: "custom-tour-tooltip",
  headerClass: "custom-tour-header",
  contentClass: "custom-tour-content",
  actionsClass: "custom-tour-actions",
};

export const residentsTourGuide = [
  {
    id: "create-resident",
    title: "Создать",
    content: "В этом процессе вы добавляете ЖК и назначаете ему тип проекта.",
    target: "#create",
    direction: "left",
    showAction: true,
    tooltip: { ...tooltip },
  },
  {
    id: "select-project",
    title: "Название ЖК",
    content: "Кликните по названию ЖК, чтобы создать проект.",
    target: "#project",
    direction: "right",
    showAction: true,
    tooltip: { ...tooltip },
  },
];

export const pojectsTourGuide = [
  {
    id: "create-project-guide",
    title: "Создать проект",
    content: "В этом процессе вы создаёте новые проекты, добавляя подъезды.",
    target: "#create-project",
    direction: "left",
    showAction: true,
    tooltip: { ...tooltip },
  },
  {
    id: "project-info-guide",
    title: "ID проекта",
    content:
      "Нажав на ID проекта, вы можете просмотреть и отредактировать его.",
    target: "#project-info",
    direction: "right",
    showAction: true,
    tooltip: { ...tooltip },
  },
  {
    id: "project-executor-guide",
    title: "Исполнители",
    content:
      "Нажав на исполнителя, вы можете назначить исполнителя проекта и отредактировать его.",
    target: "#project-executor",
    direction: "right",
    showAction: true,
    tooltip: { ...tooltip },
  },
  {
    id: "project-status-guide",
    title: "Сформировать",
    content: 'Нажав на кнопку "Сформировать", вы сможете сформировать договор.',
    target: "#project-status",
    direction: "left",
    showAction: true,
    tooltip: { ...tooltip },
  },
];